import { CheckCircle as SuccessIcon } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/checkout-success')({
  component: CheckoutSuccessPage,
});

function CheckoutSuccessPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="sm">
        <Paper 
          sx={{ 
            p: 6, 
            textAlign: 'center', 
            borderRadius: 4,
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: 8,
            bgcolor: 'background.paper',
          }}
        >
          <SuccessIcon sx={{ fontSize: 80, color: 'success.main', mb: 3 }} />
          
          <Typography variant="h3" component="h1" gutterBottom fontWeight={800}>
            {t('pricing.subscriptionSuccess')}
          </Typography>
          
          <Typography variant="h6" color="text.secondary" sx={{ mb: 4, fontWeight: 400 }}>
            {t('pricing.subscriptionSuccessDesc', { planName: 'your chosen plan' })}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 4, fontStyle: "italic" }}>
            {t('pricing.checkoutSuccessNotice')}
          </Typography>

          <Button 
            variant="contained" 
            size="large" 
            fullWidth
            onClick={() => navigate({ to: '/profile' })}
            sx={{ 
              py: 1.5, 
              fontWeight: 700, 
              bgcolor: 'primary.main',
              '&:hover': { bgcolor: 'primary.dark' }
            }}
          >
            {t('profile.goToProfile')}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}
